import { APIS } from '@/utilities/constants';
import axiosInstance from '@/services';
import { LocalStorageService } from 'br2s-ui-common-utils-02';

export const TodoAPI = {
  /**
   * API service to get /api/todo/v1/ez/items
   * @param params string
   * @returns items
   */
  todoItems: async (
    sortOrder: string,
    pageSize: number,
    pageNumber: number,
  ) => {
    const { uen } = LocalStorageService.getAuthInfo('uen', 'user');
    const auth_type = localStorage.getItem('auth_type');
    const params = {
      ...(auth_type !== 'singpass' ? { uen } : {}),
      sortOrder,
      pageSize,
      pageNumber,
    };

    const response = await axiosInstance.get(APIS.TODO_LIST, { params });
    return response;
  },

  profile_details: async (uen = '') => {
    const response = await axiosInstance.get(APIS.REGISTRY_PROFILE_DETAILS, {
      params: { uen },
    });
    return response;
  },

  getEnforcementPaymentDetails: async (enforcementId: string | undefined) => {
    const response = await axiosInstance.post(
      `${APIS.ENFORCEMENT_PAYMENT_DETAILS}/${enforcementId}`,
    );

    return response;
  },
};
